import Account from 'static/models/Account';

export function getGuaranteedText(account: Account, includeItem?: boolean): string {
    if (account.state === 'MA') {
        return 'Cost Protected';
    } else {
        return includeItem ? 'Guaranteed Item' : 'Guaranteed';
    }
}
